/**
 * Full-page loading screen with brand-aligned animations.
 * Spinner circle with logo in center; message below.
 * Dark variant: navy background. Light variant: light gray background.
 */
import React from "react";

const BRAND = {
  navy: "#01014C",
  cyan: "#36D1FF",
  cream: "#FFFDFB",
  blue: "#0A0A80",
};

const LOGO_SRC = "/logo1921.png";

function SpinnerWithLogo({ variant }) {
  const isDark = variant === "dark";
  const ringColor = BRAND.cyan;
  const ringBg = isDark ? "rgba(255,255,255,0.1)" : "#e5e7eb";
  return (
    <div className="relative flex items-center justify-center" style={{ width: 72, height: 72 }}>
      {/* Spinner ring */}
      <div
        className="absolute inset-0 rounded-full border-2 animate-spin"
        style={{
          borderColor: ringBg,
          borderTopColor: ringColor,
        }}
      />
      {/* Logo in center */}
      <img
        src={LOGO_SRC}
        alt=""
        className="relative w-10 h-10 object-contain"
        aria-hidden
      />
    </div>
  );
}

function LoadingScreen({ message = "Loading...", variant = "light", compact = false }) {
  const isDark = variant === "dark";

  if (isDark) {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden"
        style={{ background: BRAND.navy, color: BRAND.cream }}
      >
        {/* bgGlow-style gradient */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: `
              radial-gradient(900px 620px at 18% 18%, rgba(54, 209, 255, 0.22), transparent 62%),
              radial-gradient(760px 520px at 78% 22%, rgba(10, 10, 128, 0.22), transparent 58%),
              radial-gradient(980px 780px at 52% 92%, rgba(54, 209, 255, 0.12), transparent 62%)
            `,
          }}
        />
        <div className="relative z-10 flex flex-col items-center gap-6">
          <SpinnerWithLogo variant="dark" />
          <p className="text-sm font-medium" style={{ color: "rgba(234,241,255,0.9)" }}>
            {message}
          </p>
        </div>
      </div>
    );
  }

  // Light variant
  return (
    <div className={`flex flex-col items-center justify-center bg-gray-50 ${compact ? "min-h-[200px] py-12" : "min-h-screen"}`}>
      <SpinnerWithLogo variant="light" />
      <p className="mt-4 text-sm font-medium text-gray-600">{message}</p>
    </div>
  );
}

export default LoadingScreen;
